<template>
  <div class="yxtbiz-doc-viewer" :class="['yxtbiz-doc-viewer--' + modeValue, preview ? 'preview' : '']">
    <div v-if="loading" class="yxtbiz-doc-viewer__loading"></div>
    <div v-if="error" class="yxtbiz-doc-viewer__error"></div>
    <!-- <img-viewer v-if="previewSingleImg" v-model="current" :scale="scaleLevel" @zoom-visible-change="zoomVisibleChange"></img-viewer> -->
    <pdf-viewer v-if="type === 'pdf' || previewSingleImg" ref="viewer" v-model="current" :initRotate="initRotate" :imgScale="initScale" :scale="scaleLevel" @zoom-visible-change="zoomVisibleChange"></pdf-viewer>
    <ppt-viewer v-if="type === 'ppt'" ref="viewer" v-model="current" :scale="scaleLevel" @zoom-visible-change="zoomVisibleChange"></ppt-viewer>
    <tencent-viewer
      v-if="isTencentType && !previewSingleImg"
      v-model="current"
      :fileId="fileId"
      ref="viewer"
      @pageChange="onPageChange"
      @totalPage="syncPageCount"
    ></tencent-viewer>
    <template v-if="type === 'ppt' && !preview"><!-- ppt左右翻页箭头 -->
      <div class="yxtbiz-doc-viewer__ppt-arrow--left" :class="current === 1 ? '' : 'yxtbiz-doc-viewer__ppt-arrow'" @click="prevClick">
        <yxt-svg icon-class="arrow-left" />
      </div>
      <div class="yxtbiz-doc-viewer__ppt-arrow--right" :class="current === count ? '' : 'yxtbiz-doc-viewer__ppt-arrow'" @click="nextClick">
        <yxt-svg icon-class="arrow-right" />
      </div>
    </template>

    <!-- 文档播放工具栏 -->
    <div v-if="!preview" class="yxtbiz-doc-viewer__toolbar">
      <span class="mr32 lh0" v-if="showMode" v-show="modeValue === 'sun'" @click="modeChange('night')"><yxtf-svg icon-class="f_night" width="22px" height="22px" /></span>
      <span class="mr32 lh0" v-if="showMode" v-show="modeValue === 'night'" @click="modeChange('sun')"><yxtf-svg icon-class="f_sun" width="22px" height="22px" /></span>
      <span class="mr32 lh0" v-if="showZoom && !isTencentType" v-show="zoomVisible && width" :class="scaleLevel === 10 ? 'yxtbiz-doc-viewer__icon--disabled' : ''" @click="zoom(scaleLevel + 1)">
        <yxtf-svg icon-class="f_zoom-in-2" width="20px" height="20px" />
      </span>
      <span class="mr32 lh0" v-if="showZoom && !isTencentType" v-show="zoomVisible && width" :class="scaleLevel === -5 ? 'yxtbiz-doc-viewer__icon--disabled' : ''" @click="zoom(scaleLevel - 1)">
        <yxtf-svg icon-class="f_zoom-out-2" width="20px" height="20px" />
      </span>
      <span class="mr32 lh0" v-if="showFullscreen" v-show="zoomVisible && !fullscreen" @click="intoFullscreen"><yxtf-svg icon-class="f_fullscreen" width="18px" height="18px" /></span>
      <span class="mr32 lh0" v-if="showFullscreen" v-show="zoomVisible && fullscreen" @click="exitFullscreen"><yxtf-svg icon-class="f_fullscreen-exit" width="18px" height="18px" /></span>
      <span class="ml24 mr24 lh0" :class="[current === 1 ? 'yxtbiz-doc-viewer__icon--disabled' : '', !showMode && !showZoom && !showFullscreen ? 'ml24' : '']" @click="prevClick"><yxtf-svg icon-class="f_up-circle-o" width="20px" height="20px" /></span>
      <yxt-input v-model="input" @keydown.enter.native="currentInput" @blur="input=current"></yxt-input>
      <span class="mr24 yxtbiz-doc-viewer__toolbar-text">/ {{count}} {{$t('pc_biz_doc_lbl_page')}}</span>
      <span class="mr24 lh0" :class="current === count ? 'yxtbiz-doc-viewer__icon--disabled' : ''" @click="nextClick"><yxtf-svg icon-class="f_down-circle-o" width="20px" height="20px" /></span>
      <!-- <span class="lh0" v-if="bTencent" @click="exchange"><yxtf-svg class="hand" :remote-url="mediaUrl" icon-class="exchange" width="16px" height="16px" /></span> -->
    </div>
    <!-- 文档预览工具栏 -->
    <div v-if="preview && fileType !== 'excel'" class="yxtbiz-doc-viewer__toolbar preview">
      <div class="preview-info">
        <yxtf-tooltip
          v-if="!previewSingleImg || isTencentType"
          :content="$t('pc_biz_doc_lbl_prevPage' /* 上一页 */ )"
          placement="top"
          effect="ellipsis"
          :open-filter="false"
          :max-width="200">
          <span @click="prevClick" class="ml8 mr16 lh0" :class="current === 1 ? 'yxtbiz-doc-viewer__icon--disabled' : ''"><yxtf-svg icon-class="f_up-circle-o" width="20px" height="20px" /></span>
        </yxtf-tooltip>
        <yxtf-tooltip
          v-if="!previewSingleImg || isTencentType"
          :content="$t('pc_biz_input_toturn' /* 输入页面可跳转 */ )"
          placement="top"
          effect="ellipsis"
          :open-filter="false"
          :max-width="200">
          <yxt-input v-model="input" @keydown.enter.native="currentInput" @blur="input=current"></yxt-input>
        </yxtf-tooltip>

        <span v-if="!previewSingleImg || isTencentType" class="mr16 yxtbiz-doc-viewer__toolbar-text">/ {{count}}页</span>

        <yxtf-tooltip
          v-if="!previewSingleImg || isTencentType"
          :content="$t('pc_biz_doc_lbl_nextPage' /* 下一页 */ )"
          placement="top"
          effect="ellipsis"
          :open-filter="false"
          :max-width="200">
          <span @click="nextClick" class="mr16 lh0" :class="current === count ? 'yxtbiz-doc-viewer__icon--disabled' : ''"><yxtf-svg icon-class="f_down-circle-o" width="20px" height="20px" /></span>
        </yxtf-tooltip>

        <yxtf-tooltip
          v-if="showFullscreen" v-show="zoomVisible && !fullscreen"
          :content="$t('pc_biz_imgviewer_btn_fullscreen' /* 全屏 */ )"
          placement="top"
          effect="ellipsis"
          :open-filter="false"
          :max-width="200">
          <span class="lh0" @click="intoFullscreen"><yxtf-svg icon-class="f_fullscreen" width="18px" height="18px" /></span>
        </yxtf-tooltip>
        <yxtf-tooltip
          v-if="showFullscreen" v-show="zoomVisible && fullscreen"
          :content="$t('pc_biz_imgviewer_btn_nofullscreen' /* 退出全屏 */ )"
          placement="top"
          effect="ellipsis"
          :open-filter="false"
          :max-width="200">
          <span class="lh0" @click="exitFullscreen"><yxtf-svg icon-class="f_fullscreen-exit" width="18px" height="18px" /></span>
        </yxtf-tooltip>
        <div v-if="previewSingleImg && initList.length && initList.length === 1">
          <yxtf-tooltip
            :content="$t('pc_biz_imgviewer_btn_scale_in' /* 放大 */ )"
            placement="top"
            effect="ellipsis"
            :open-filter="false"
            :max-width="200">
            <span @click="scale('in')" class="icon-scale1" data-viewer-action="zoom-in"></span>
          </yxtf-tooltip>
        </div>
        <div v-if="previewSingleImg && initList.length && initList.length === 1">
          <yxtf-tooltip
            :content="$t('pc_biz_imgviewer_btn_scale_out' /* 缩小 */ )"
            placement="top"
            effect="ellipsis"
            :open-filter="false"
            :max-width="200">
            <span @click="scale('out')" class="icon-scale2" data-viewer-action="zoom-out"></span>
          </yxtf-tooltip>
        </div>
        <div v-if="previewSingleImg && !fullscreen">
          <yxtf-tooltip
            :content="$t('pc_biz_imgviewer_btn_fullscreen' /* 全屏 */ )"
            placement="top"
            effect="ellipsis"
            :open-filter="false"
            :max-width="200">
            <span @click="intoFullscreen" data-viewer-action="play" class="icon-full-screen"></span>
          </yxtf-tooltip>
        </div>
        <div v-if="previewSingleImg && fullscreen">
          <yxtf-tooltip
            :content="$t('pc_biz_imgviewer_btn_init' /* 适应页面 */ )"
            placement="top"
            effect="ellipsis"
            :open-filter="false"
            :max-width="200">
            <span @click="exitFullscreen" data-viewer-action="reset" class="icon-reset-img"></span>
          </yxtf-tooltip>
        </div>
        <div v-if="previewSingleImg && initList.length && initList.length === 1">
          <yxtf-tooltip
            :content="$t('pc_biz_imgviewer_btn_rotate' /* 旋转 */ )"
            placement="top"
            effect="ellipsis"
            :open-filter="false"
            :max-width="200">
            <span @click="transform" data-viewer-action="rotate-left" class="icon-turn-transform"></span>
          </yxtf-tooltip>
        </div>
        <div class="lines"></div>
        <div>
          <yxtf-tooltip
            :content="$t('pc_biz_import_btn_download' /* 下载 */ )"
            placement="top"
            effect="ellipsis"
            :open-filter="false"
            :max-width="200">
            <span @click="download" class="icon-download"></span>
          </yxtf-tooltip>
        </div>
        <!-- <div>
          <yxtf-tooltip
            :content="$t('pc_biz_lbl_joinlib' /* 加入知识库 */ )"
            placement="top"
            effect="ellipsis"
            :open-filter="false"
            :max-width="200">
            <span @click="addToKngStore" class="icon-folder-add"></span>
          </yxtf-tooltip>
        </div> -->
        <!-- <span class="lh0" v-if="bTencent" @click="exchange"><yxtf-svg class="hand" :remote-url="mediaUrl" icon-class="exchange" width="16px" height="16px" /></span> -->
      </div>
    </div>
  </div>
</template>

<script>
import screenfull from 'screenfull';
import PdfViewer from './components/PdfViewer';
import PptViewer from './components/PptViewer';
import TencentViewer from './components/TencentViewer';
import { getFileInfo, getPlayInfo } from './service';
import { FrontSvgIcon } from 'yxt-pc';
import { getMedia } from 'yxt-biz-pc/packages/api';
export default {
  name: 'YxtbizDocViewer',
  components: {
    PdfViewer,
    PptViewer,
    TencentViewer,
    YxtfSvg: FrontSvgIcon
  },
  props: {
    fileId: String, // 如果传入了fileId，则自动调用接口获取文档转码后播放信息，优先级高于fileInfo
    fileInfo: Object, // 如果不传入fileId，取fileInfo播放
    width: Number, // 文档宽度
    start: { // 起始页
      type: Number,
      default: 1
    },
    // 是否腾讯文档
    tengxunDoc: {
      type: Boolean,
      default: false
    },
    loadingUrl: String, // 加载中背景图片
    mode: { // 日间、夜间模式
      type: String,
      default: 'sun',
      validator: value => {
        return ['sun', 'night'].indexOf(value) > -1;
      }
    },
    showMode: { // 显示模式
      type: Boolean,
      default: true
    },
    showZoom: { // 显示放大、缩小
      type: Boolean,
      default: true
    },
    showFullscreen: { // 显示全屏
      type: Boolean,
      default: true
    },
    rightMenuDisabled: { // 禁用右键菜单
      type: Boolean,
      default: true
    },
    watermarkConfig: { // 水印配置
      type: Object
    },
    preview: {
      type: Boolean,
      default: false
    },
    previewSingleImg: {
      type: Boolean,
      default: false
    },
    fileType: {
      type: String,
      default: ''
    },
    downloadCb: {
      type: Function,
      default: () => {}
    },
    addToKngStoreCb: {
      type: Function,
      default: () => {}
    },
    fileIdCopy: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      error: false,
      type: '',
      modeValue: ['sun', 'night'].indexOf(this.mode) > -1 ? this.mode : 'sun',
      scaleLevel: 0,
      fullscreen: false,
      count: 1,
      current: 1,
      input: 1,
      initList: [],
      imageWidth: null,
      imageHeight: null,
      zoomVisible: true,
      bTencent: false,
      //   fileType: '',
      mediaUrl: getMedia() + '/common/pc_front_svg',
      initScale: 1,
      initRotate: 0,
      speed: 0.1 // 放大缩小倍数
    };
  },
  watch: {
    current() {
      this.input = this.current;
      this.$emit('page-change', this.current);
    }
  },
  computed: {
    isTencentType() {
      return this.type === 'tencent';
    }
  },
  async created() {
    if (this.fileId) {
      await this.getFileInfoByApi();
    } else {
      await this.analysisFileInfo();
    }
  },
  mounted() {
    if (this.rightMenuDisabled) {
      this.$el.oncontextmenu = () => { return false; };
    }
    if (screenfull && screenfull.isEnabled) {
      screenfull.on('change', this.fullscreenChange);
    }
  },
  beforeDestroy() {
    screenfull.off('change', this.fullscreenChange);
  },
  destroyed() {
    screenfull.off('change', this.fullscreenChange);
  },
  methods: {
    download() {
      this.downloadCb(this.fileId || this.fileIdCopy);
    },
    addToKngStore() {
      this.addToKngStoreCb(this.fileId || this.fileIdCopy);
    },
    exchange() {
      if (this.type === 'tencent') {
        this.getPlayInfoByApi();
      } else {
        this.type = 'tencent';
      }
    },
    async getFileInfoByApi() { // 调用api获取fileInfo
      this.loading = true;
      try {
        const fileInfo = await getFileInfo(this.fileId);
        if (fileInfo.platform === 'tencent') {
          this.current = this.start || 1;
          this.type = 'tencent';
          this.bTencent = true;
          this.loading = false;
        } else {
          await this.getPlayInfoByApi();
        }
      } catch (e) {
        this.error = true;
        console.error(e, 'getFileInfo error');
      }
    },
    async getPlayInfoByApi() {
      const res = await getPlayInfo(this.fileId);
      const desc = JSON.parse(res[0].desc);
      this.count = desc.count;
      this.current = this.start <= 0 ? 1 : (this.start > this.count ? this.count : this.start);
      this.initList = res.map((v, i) => {
        return {
          url: v.url,
          pageIndex: i + 1
        };
      });
      if (desc.width && desc.height) {
        this.imageWidth = desc.width;
        this.imageHeight = desc.height;
      } else if (this.initList[0].url) {
        const firstImage = this.initList[0];
        if (firstImage.url) {
          try {
            await this.getFirstImageSize(firstImage.url);
          } catch (e) {
            console.log(e);
          }
        }
      }

      this.type = this.imageWidth > this.imageHeight ? 'ppt' : 'pdf';
      this.loading = false;
    },
    async analysisFileInfo() { // 解析传入的fileInfo
      if (this.fileInfo && this.fileInfo.list instanceof Array && this.fileInfo.list.length > 0) {
        this.initList = [...this.fileInfo.list];
        this.count = this.initList.length;
        this.current = this.start <= 0 ? 1 : (this.start > this.count ? this.count : this.start);
        if (this.fileInfo.width && this.fileInfo.height) {
          this.imageWidth = this.fileInfo.width;
          this.imageHeight = this.fileInfo.height;
        } else {
          const firstImage = this.initList[0];
          if (firstImage.url) {
            try {
              await this.getFirstImageSize(firstImage.url);
            } catch (e) {
              this.error = true;
              return;
            }
          }
        }
        this.type = this.imageWidth > this.imageHeight ? 'ppt' : 'pdf';
      } else {
        this.error = true;
      }
    },
    async getFirstImageSize(url) {
      if (!url) {
        return Promise.reject(new Error('get image failed'));
      }
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          this.imageWidth = img.width;
          this.imageHeight = img.height;
          resolve({
            width: img.width,
            height: img.height
          });
        };

        img.onerror = (err) => {
          console.log(err);
          reject(new Error('get image failed'));
        };
        img.src = url;
      });

    },
    syncPageCount(count) {
      this.count = count;
    },
    onPageChange(e) {
      if (e && this.current !== e) {
        this.current = e;
      }
    },
    modeChange(mode) { // 日间、夜间模式切换
      this.modeValue = mode;
      this.$emit('mode-change', mode);
    },
    zoom(level) { // 缩放
      if (level < -5 || level > 10 || level === this.scaleLevel) { // level值不合法或没改变
        return;
      }
      this.scaleLevel = level;
    },
    intoFullscreen() { // 进入全屏
      screenfull.request(this.$el);
      this.scaleLevel = 0;
    },
    exitFullscreen() { // 退出全屏
      screenfull.exit();
      this.scale('init');
    },
    fullscreenChange() { // 全屏改变
      this.fullscreen = screenfull.isFullscreen;
      if (!this.fullscreen) {
        this.scaleLevel = 0;
      }
      this.$emit('fullscreen-change', this.fullscreen);
    },
    currentInput() { // 输入页码回车
      let value = ~~this.input;
      if (value > 0 && value <= this.count) {
        this.current = value;
        this.$refs.viewer.navigate(value);
      } else {
        this.input = this.current;
      }
    },
    scrollToPage(page) {
      this.input = page;
      this.currentInput();
    },
    prevClick() { // 上一页
      if (this.current > 1) {
        this.current--;
        this.$refs.viewer.navigate(this.current);
      }
    },
    nextClick() { // 下一页
      if (this.current < this.count) {
        this.current++;
        this.$refs.viewer.navigate(this.current);
      }
      if (this.current === this.count && this.fullscreen) {
        this.$fmessage({
          showClose: true,
          message: this.$t('pc_biz_lbl_esc_out' /* 已是最后一页，按 ESC 退出 */)
        });
      }
    },
    zoomVisibleChange(visible) { // 缩放、全屏可见改变
      this.zoomVisible = visible;
      if (this.scaleLevel !== 0 && !visible) {
        this.scaleLevel = 0;
      }
    },
    scale(value) {
      // in out init
      let initScale = this.initScale;
      if (value === 'in') {
        if (initScale < 10) {
          this.initScale = initScale + this.speed;
        } else {
          console.log('已放大100倍, 不能再放大了');
        }
      } else if (value === 'out') {
        if (initScale > 0.1) {
          this.initScale = initScale - this.speed;
        } else {
          console.log('已经缩小10倍了, 不能缩小了');
        }
      } else if (value === 'init') {
        this.initScale = 1;
      }
    },
    transform() {
      let initRotate = this.initRotate;
      this.initRotate = (initRotate - 90) % 360;
    }
  }
};
</script>
<style lang="scss">
.preview-info {
  height: 24px;
  line-height: 24px;
  background: #fff;
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.12);
  border-radius: 22px;
  padding: 10px 30px;
  .lines {
    width: 1px;
    height: 24px;
    background: #e9e9e9;
  }
  & > div {
    width: 28px;
    height: 28px;
    background-color: transparent;
    opacity: 1;
    margin: 0 6px;
    text-align: center;
    & > input {
      vertical-align: middle;
      height: 28px;
    }
    &:hover {
      background-color: #f0f0f0;
      border-radius: 4px;
    }
    span {
      display: inline-block;
      vertical-align: middle;
      width: 24px;
      height: 24px;
    }
  }
}
.icon-scale1 {
  background: url('data:image/svg+xml;base64,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') center center no-repeat;
  background-size: cover;
}
.icon-scale2 {
  background: url('data:image/svg+xml;base64,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') center center no-repeat;
  background-size: cover;
}
.icon-full-screen {
  background: url('data:image/svg+xml;base64,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') center center no-repeat;
  background-size: cover;
}
.icon-reset-img {
  background: url('data:image/svg+xml;base64,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') center center no-repeat;
  background-size: cover;
}
.icon-turn-transform {
  background: url('data:image/svg+xml;base64,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') center center no-repeat;
  background-size: cover;
}
.icon-download {
  background: url('data:image/svg+xml;base64,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') center center no-repeat;
  background-size: cover;
}
.icon-folder-add {
  background: url('data:image/svg+xml;base64,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') center center no-repeat;
  background-size: cover;
}
</style>
